var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-icon",attrs:{"align":"center"}},[_c('div',{staticClass:"r-icon--wrap"},[(_vm.isSpecialIcon)?_c('img',{attrs:{"src":require(`@/assets/icons/${_vm.icon}.svg`)}}):_c('i',{class:_vm.classList})])])
}
var staticRenderFns = []

export { render, staticRenderFns }